/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $on = _ref.$on,
      $update = _ref.$update;

  var checkHistory = function checkHistory() {
    $f7.request({
      method: 'get',
      url: window.path + 'static/api/trade.php?action=get&AccountNumber=' + localStorage.getItem('AccountNumber'),
      success: function success(data) {
        //console.log("Output:" + data);
        data = JSON.parse(data);
        var list = "";
        var profit = 0;
        if (data != null) for (var i = 0; i < data.length; i++) {
          //console.log(data[i].OrderTicket);
          var OrderType = "";
          var OrderTypeColor = "";
          var OrderProfitColor = "";

          if (data[i].OrderType == "0") {
            OrderType = "buy";
            OrderTypeColor = "#508AFF";
          }

          if (data[i].OrderType == "1") {
            OrderType = "sell";
            OrderTypeColor = "#FF3737";
          }

          if (parseFloat(data[i].OrderProfit) > 0) OrderProfitColor = "#508AFF";else OrderProfitColor = "#FF3737";
          profit += parseFloat(data[i].OrderProfit);
          if (i > data.length - 100) list += "\n        <li>\n            <div class=\"item-content\" style=\"height:50px\">\n              <div class=\"item-inner\">\n                <div class=\"item-title\"><B><span style=\"font-size:14px;\">XAUUSD,</span> <span style=\"font-size:14px;color:" + OrderTypeColor + "\">" + OrderType + " " + parseFloat(data[i].OrderLots).toFixed(2) + "</span></B><br/><span style=\"color:darkgray;font-size:14px;\">" + parseFloat(data[i].OrderOpenPrice).toFixed(2) + " \u2192 " + parseFloat(data[i].OrderClosePrice).toFixed(2) + " <span></div>\n                <div class=\"item-after\" style=\"text-align:right\"><span style=\"font-size:12px;color:darkgray\">" + data[i].DateTime + "<span><br/><span style=\"font-size:16px;color:" + OrderProfitColor + "\"><b>" + parseFloat(data[i].OrderProfit).toFixed(2) + "</b></span></div>\n              </div>\n            </div>\n          </li>\n        ";
        }
        $(".content-history").html(list);
        $(".profit-history").html("US$" + profit.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
      }
    });
  };

  $on('pageInit', function () {
    checkHistory();
    setInterval(function () {
      checkHistory();
    }, 60000);
    setInterval(function () {
      if (window.checkNowHistory == true) {
        window.checkNowHistory = false;
        checkHistory();
      }
    }, 1000);
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="title">History</div>
    </div>
  </div>
  <div class="page-content page-content-history" style="font-family: 'Roboto Condensed';"> 

    <div class="list" style="margin-top: 0px;">
      <ul class="content-history" style="background-color: black">

      </ul>
    </div>
    <div class="list" style="margin-top: -40px;">
      <ul class="" style="background-color: black;">
        <li>
          <div class="item-content">
            <div class="item-inner">
              <div class="item-title" ><b><span style="color:darkgray;font-size:16px">Profit:<BR/>Balance:<BR/>Order Count:</span></b></div>
              <div class="item-after" style="text-align:right;">
                <b>
                <span style="color:darkgray;font-size:16px">
                  <span class="profit-history">0</span>
                  <BR/>
                  <span class="balance">0</span>
                  <BR/>
                  <span class="OrderCount">0</span>
                </span>
                </b>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '8503da951f';
export default framework7Component;